'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _lodash = require('lodash');

var _serviceConfigurationPropType = require('../PropTypes/serviceConfigurationPropType');

var _serviceConfigurationPropType2 = _interopRequireDefault(_serviceConfigurationPropType);

var _windowPropType = require('../PropTypes/windowPropType');

var _windowPropType2 = _interopRequireDefault(_windowPropType);

var _NewSpotSuggestionModel = require('./NewSpotSuggestion/NewSpotSuggestionModel');

var _NewSpotSuggestionRender = require('./NewSpotSuggestion/NewSpotSuggestionRender');

var _NewSpotSearchInput = require('../NewSpotSearchInput');

var _NewSpotSearchInput2 = _interopRequireDefault(_NewSpotSearchInput);

var _analytics = require('./analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uuid = function uuid() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (a) {
    return (a ^ Math.random() * 16 >> a / 4).toString(16);
  });
};

var NewSpotSearch = function (_Component) {
  (0, _inherits3.default)(NewSpotSearch, _Component);

  function NewSpotSearch(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, NewSpotSearch);

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    var _this = (0, _possibleConstructorReturn3.default)(this, (NewSpotSearch.__proto__ || (0, _getPrototypeOf2.default)(NewSpotSearch)).call(this, props));

    _this.onChange = function (event, _ref) {
      var newValue = _ref.newValue;

      _this.setState({
        value: newValue
      });
    };

    _this.onKeyDown = function (event) {
      var window = _this.props.window;

      if (event.key === 'Enter' && !_this.suggestionSelected) {
        event.preventDefault();
        window.location.href = '/search/' + _this.state.value;
      }
    };

    _this.onSearchFieldFocus = function () {
      var _this$props = _this.props,
          window = _this$props.window,
          serviceUrl = _this$props.serviceConfig.serviceUrl;

      var searchId = uuid();
      _this.setState({ searchId: searchId });
      (0, _analytics.focusedSearch)(window, serviceUrl, { searchId: searchId });
    };

    _this.onSuggestionsFetchRequested = function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref3) {
        var value = _ref3.value;
        var serviceConfig, searchId, suggestions, typeResultsCount, spotHits, subregionHits, geonameHits, travelHits, hits;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                serviceConfig = _this.props.serviceConfig;
                searchId = _this.state.searchId;
                _context.next = 4;
                return (0, _NewSpotSuggestionModel.getSuggestedSpots)(serviceConfig, value, 10);

              case 4:
                suggestions = _context.sent;
                typeResultsCount = {
                  'spot-suggest': 10,
                  'subregion-suggest': 3,
                  'geoname-suggest': 3,
                  'travel-suggest': 3
                };

                suggestions = suggestions.map(function (suggestion) {
                  var newSuggestion = (0, _lodash.cloneDeep)(suggestion);
                  var key = (0, _keys2.default)(suggestion.suggest)[0];
                  newSuggestion = (0, _extends3.default)({}, newSuggestion, {
                    hits: (0, _extends3.default)({}, newSuggestion.hits, {
                      hits: newSuggestion.hits.hits.slice(0, typeResultsCount[key])
                    })
                  });
                  newSuggestion.suggest[key][0].options = newSuggestion.suggest[key][0].options.slice(0, typeResultsCount[key]);
                  return newSuggestion;
                });

                spotHits = suggestions[0].hits.hits.length;
                subregionHits = suggestions[1].hits.hits.length;
                geonameHits = suggestions[2].hits.hits.length;
                travelHits = suggestions[3].hits.hits.length;


                (0, _analytics.query)(serviceConfig.serviceUrl, {
                  searchId: searchId,
                  value: value,
                  spotHits: spotHits,
                  subregionHits: subregionHits,
                  geonameHits: geonameHits,
                  travelHits: travelHits
                });

                // return hits if available or else all suggestions
                hits = suggestions.filter(function (sug) {
                  return sug.hits.hits.length > 0;
                });

                _this.setState({
                  suggestions: hits && hits.length > 0 ? hits : suggestions,
                  searchTerm: value
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.onSuggestionsClearRequested = function () {
      _this.setState({
        suggestions: []
      });
    };

    _this.onSuggestionSelected = function (event, value) {
      var _value$suggestion = value.suggestion,
          name = _value$suggestion.name,
          _type = _value$suggestion._type,
          href = _value$suggestion._source.href,
          suggestionIndex = value.suggestionIndex;
      var _this$props2 = _this.props,
          window = _this$props2.window,
          serviceUrl = _this$props2.serviceConfig.serviceUrl;
      var _this$state = _this.state,
          searchId = _this$state.searchId,
          searchTerm = _this$state.searchTerm,
          suggestions = _this$state.suggestions;

      var took = suggestions[suggestionIndex] ? suggestions[suggestionIndex].took : null;
      _this.suggestionSelected = true;

      (0, _analytics.clickedSearchResults)(window, serviceUrl, {
        searchId: searchId,
        searchResultRank: suggestionIndex,
        destinationPage: href,
        queryTerm: searchTerm,
        resultName: name,
        searchLatency: took,
        resultType: _type
      }, function () {
        return _this.navigateToResult(href);
      });
    };

    _this.navigateToResult = function (href) {
      _this.props.window.location.assign(href);
    };

    _this.state = {
      value: '',
      suggestions: [],
      searchTerm: '',
      searchId: null,
      initialRender: true
    };

    _this.suggestionSelected = false;
    return _this;
  }

  (0, _createClass3.default)(NewSpotSearch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // React has trouble reconciling aria labels between server/client
      // See: https://github.com/facebook/react/issues/5867
      // The suggested solution is to disable server side rendering for these components
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ initialRender: false });
    }

    // Autosuggest will call this function every time you need to update suggestions.


    // Autosuggest will call this function every time you need to clear suggestions.

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          value = _state.value,
          suggestions = _state.suggestions,
          searchTerm = _state.searchTerm,
          initialRender = _state.initialRender;

      if (initialRender) return null;

      var _props = this.props,
          window = _props.window,
          placeholder = _props.placeholder;

      var theme = {
        container: 'quiver-search__container',
        containerOpen: 'quiver-search__container--open',
        input: 'quiver-new-navigation-bar__search__wrapper__input',
        inputOpen: 'quiver-search__input--open',
        inputFocused: 'quiver-search__input--focused',
        suggestionsContainer: 'quiver-search__suggestions-container',
        suggestionsContainerOpen: 'quiver-search__suggestions-container--open',
        suggestionsList: 'quiver-search__suggestions-list',
        suggestion: 'quiver-search__suggestion',
        suggestionFirst: 'quiver-search__suggestion--first',
        suggestionHighlighted: 'quiver-search__suggestion--highlighted',
        sectionContainer: 'quiver-search__section-container',
        sectionContainerFirst: 'quiver-search__section-container--first',
        sectionTitle: 'quiver-search__section-title'
      };

      // Autosuggest will pass through all these props to the input element.
      var inputProps = {
        placeholder: placeholder,
        value: value,
        onChange: this.onChange,
        onFocus: this.onSearchFieldFocus
      };

      var conditionalProps = {};
      conditionalProps.renderSuggestionsContainer = (0, _NewSpotSuggestionRender.getRenderSuggestionsContainer)(window);
      inputProps.onKeyDown = this.onKeyDown;

      return _react2.default.createElement(_reactAutosuggest2.default, (0, _extends3.default)({
        id: 'new-spot-search',
        theme: theme,
        multiSection: true,
        highlightFirstSuggestion: false,
        inputProps: inputProps,
        suggestions: suggestions,
        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        onSuggestionSelected: this.onSuggestionSelected,
        getSectionSuggestions: _NewSpotSuggestionModel.getSectionSuggestions,
        getSuggestionValue: _NewSpotSuggestionModel.getSuggestionValue,
        renderInputComponent: function renderInputComponent(props) {
          return _react2.default.createElement(_NewSpotSearchInput2.default, { inputProps: props });
        },
        renderSectionTitle: _NewSpotSuggestionRender.renderSectionTitle,
        renderSuggestion: (0, _NewSpotSuggestionRender.renderSuggestion)(searchTerm)
      }, conditionalProps));
    }
  }]);
  return NewSpotSearch;
}(_react.Component);

NewSpotSearch.propTypes = {
  serviceConfig: _serviceConfigurationPropType2.default.isRequired,
  placeholder: _propTypes2.default.string,
  window: _windowPropType2.default
};
NewSpotSearch.defaultProps = {
  placeholder: 'Search city, county, or spot...'
};
exports.default = NewSpotSearch;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewSpotSearch/NewSpotSearch.js
// module id = 612
// module chunks = 11